module.exports = __webpack_public_path__ + "static/media/sort-amount-up.bfff84c7.svg";